/** Name of the header used to authenticate requests using a signup edit token */
// eslint-disable-next-line import/prefer-default-export
export const EDIT_TOKEN_HEADER: string = "X-Edit-Token";
